"use client";

import React, { ReactNode, FC } from "react";

import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

import { SortingDropdown } from "~/components/sorting-dropdown/component";
import { getTestAutomationProps } from "~/helpers/test-automation-props";
import { Filter24 } from "~/theme/icons/components/filter";
import { Nullable } from "~/types/general.types";

import { PRODUCTS_TOP_BAR_CLASSES } from "./constants";
import { ProductsTopBarContainer } from "./styled";

export interface ProductsTopBarProps {
  className?: string;
  caption: ReactNode;
  captionMobile: ReactNode;
  productSortSelectorText?: Nullable<string>;
  onFiltersOpen: () => void;
  sortingParams: { value: string; text?: Nullable<string> }[];
  activeSortingParam?: string;
  setActiveSortingParam?: (value: string) => void;
}

export const ProductsTopBar: FC<ProductsTopBarProps> = ({
  className,
  caption,
  captionMobile,
  productSortSelectorText,
  onFiltersOpen,
  sortingParams,
  activeSortingParam,
  setActiveSortingParam,
}) => {
  return (
    <ProductsTopBarContainer
      id="products-top-bar"
      className={className}
      {...getTestAutomationProps("products-top-bar")}
    >
      <Typography variant="body2" className={PRODUCTS_TOP_BAR_CLASSES.hideOnMobile}>
        {caption}
      </Typography>
      <Button
        id="open-filters-button"
        className={PRODUCTS_TOP_BAR_CLASSES.openFiltersBtn}
        onClick={onFiltersOpen}
        variant="text"
        startIcon={<Filter24 />}
        {...getTestAutomationProps("open-filters-button")}
      >
        <Typography variant="body1">{captionMobile}</Typography>
      </Button>
      <SortingDropdown
        label={productSortSelectorText}
        activeSortingParam={activeSortingParam}
        setActiveSortingParam={setActiveSortingParam}
        items={sortingParams}
      />
    </ProductsTopBarContainer>
  );
};
